import apiClient from './backend'
import store from './store'
import helper from './helper'
import Router from 'vue-router'

import AuthContainer from './containers/AuthContainer'
import MainContainer from './containers/MainContainer'
import NormalContainer from './containers/NormalContainer'
import SitterContainer from './containers/SitterContainer'
import ReportContainer from './containers/ReportContainer'
import LpContainer from './containers/LpContainer'

import LinkSignup from './views/auth/LinkSignup'
import Login from './views/auth/Login'
import UserList from './views/user/UserList'
import NonUserList from './views/user/NonUserList'
import UserDetail from './views/user/UserDetail'
import Dashboard from './views/Dashboard'

import SitterList from './views/sitter/SitterList'
import SitterCreate from './views/sitter/SitterCreate'
import SitterDetail from './views/sitter/SitterDetail'
import NonSitterList from './views/sitter/NonSitterList'

import NoticeList from './views/notice/NoticeList'
import NoticeNew from './views/notice/NoticeNew'
import NoticeEdit from './views/notice/NoticeEdit'
import NoticeDetail from './views/notice/NoticeDetail'
import ReportList from './views/report/ReportList'
import SitterReportList from './views/report/SitterReportList'

import Lp from './views/lp/Lp'
import Success from './views/lp/Success'
import PasswordReset from './views/auth/PasswordChange'
import PasswordResetSuccess from './views/auth/PasswordChangeSuccess'
import Privacy from './views/lp/Privacy'
import Terms from './views/lp/Terms'
import Transaction from './views/lp/Transaction'

let routes = [
  {
    path: '/',
    name: 'lp',
    component: Lp
  },
  {
    path: '/',
    component: LpContainer,
    children: [
      {
        path: 'success',
        name: 'success',
        component: Success
      },
      {
        path: 'linksignup',
        name: 'linksignup',
        component: LinkSignup
      },
      {
        path: 'passwordreset',
        name: 'passwordreset',
        component: PasswordReset
      },
      {
        path: 'passwordreset/success',
        name: 'passwordreset_success',
        component: PasswordResetSuccess
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: Privacy
      },
      {
        path: 'terms',
        name: 'terms',
        component: Terms
      },
      {
        path: 'transaction',
        name: 'transaction',
        component: Transaction
      }
    ]
  },
  {
    path: '/admin',
    redirect: {
      name: 'login'
    },
  },
  {
    path: '/admin',
    component: AuthContainer,
    children: [
      {
        path: 'login',
        name: 'login',
        component: Login
      },
    ]
  },
  {
    path: '/admin',
    component: MainContainer,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'users',
        name: 'user_list',
        component: UserList
      },
      {
        path: 'users_hidden',
        name: 'non_user_list',
        component: NonUserList
      },
    ]
  },
  {
    path: '/admin',
    component: SitterContainer,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'sitters',
        name: 'sitter_list',
        component: SitterList
      },
      {
        path: 'sitters_hidden',
        name: 'non_sitter_list',
        component: NonSitterList
      },
    ]
  },
  {
    path: '/admin',
    component: NormalContainer,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'users/:id/detail',
        name: 'user_detail',
        component: UserDetail
      },
      {
        path: 'sitters/:id/detail',
        name: 'sitter_detail',
        component: SitterDetail
      },
      {
        path: 'sitters/create',
        name: 'sitter_create',
        component: SitterCreate
      },
      {
        path: 'dashboard',
        name: 'dashboard',
        component: Dashboard
      },
      {
        path: 'notices',
        name: 'notice_list',
        component: NoticeList
      },
      {
        path: 'notices/new',
        name: 'notice_new',
        component: NoticeNew
      },
      {
        path: 'notices/:id/edit',
        name: 'notice_edit',
        component: NoticeEdit
      },
      {
        path: 'notices/:id',
        name: 'notice_detail',
        component: NoticeDetail
      },
    ]
  },
  {
    path: '/admin',
    component: ReportContainer,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'user_reports',
        name: 'user_report_list',
        component: ReportList
      },
      {
        path: 'sitter_reports',
        name: 'sitter_report_list',
        component: SitterReportList
      },
    ]
  },
]

const router = new Router({
  routes,
  linkActiveClass: 'active',
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  if (to.name == from.name || to.path == from.path) return next()
  if (to.matched.some(m => m.meta.requiresAuth)) {
    apiClient.check().then(response => {
      return next()
    }).catch(error => {
      return next({ name: 'login' })
    })
  }
  return next()
})

export default router
